"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _westfieldLogoInline = _interopRequireDefault(require("../../images/westfield-logo.inline.svg"));

var _directLogoInline = _interopRequireDefault(require("../../images/direct-logo.inline.svg"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("./index.scss"));

var LogoWithoutLink = function LogoWithoutLink(_ref) {
  var className = _ref.className,
      type = _ref.type,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "type"]);
  return type === 'direct' ? _react["default"].createElement(_directLogoInline["default"], (0, _extends2["default"])({
    className: className
  }, props)) : _react["default"].createElement(_westfieldLogoInline["default"], (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])(className, _index["default"][type])
  }));
};

LogoWithoutLink.propTypes = {
  className: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['default', 'alt', 'direct'])
};
LogoWithoutLink.defaultProps = {
  type: 'default'
};
var _default = LogoWithoutLink;
exports["default"] = _default;